 import Navbar from "../../components/navbar/Navbar"
 import styled from "./about.module.css" 
 import aks from "./../../assets/images/about.png"
 import Footer from "../../components/footer/Footer"

 function AboutUs(){
        return(
            <div>
                 <Navbar title="سایت عوض نیا" /> 
          
            <div className={styled.aboutPage}>
                 
              
                <div className="container">
                      <h2>درباره ما</h2>
                <p>
تمامی راه های ارتباطی با ما در این صفحه قرار داده شده است. شما عزیزان می توانید با شماره تلفن اصلی شرکت تماس حاصل نموده یا از راه های ارتباطی زیر پیغام خود را برای ما ارسال نمایید.
<br/>
آدرس ایمیل  
<br/>
nastaran.evaznia@gmail.com

</p>
              
                <img src={aks} alt="aks"></img>
                </div>
                <Footer ></Footer>
            </div>
              </div>
        )
    }
    export default AboutUs;